import { isString } from '@bd/vue3-utils'

export const normalizeTreeValue = (list: (BaseOption | string)[] = []): string[] =>
  list.map(item => (isString(item) ? item : (item?.value as string))) as string[]
